<p [wchfsTooltip]="CompletionType.getTranslateKey(data) | translate">
  {{ CompletionType.isCompleteWheel(data) ? ('yes' | translate | uppercase) : ('no' | translate | uppercase) }}
</p>
